import type { usePostHog } from "posthog-js/react";

/**
 * Analytics for the impromptu feature.
 *
 * Recording durations are reported as bands rather than exact seconds. An exact
 * duration alongside a prompt id and a language is close to a fingerprint of one
 * learner's attempt, and no question we want to answer — are people using the
 * whole minute? do short attempts fail more? — needs better resolution than this.
 */

type PostHogClient = ReturnType<typeof usePostHog>;

export function captureImpromptuEvent(
  posthog: PostHogClient,
  event: string,
  properties: Record<string, unknown>
) {
  // Without a key, `posthog.capture` queues events that will never be sent.
  if (!posthog || !process.env.NEXT_PUBLIC_POSTHOG_KEY) return;
  posthog.capture(event, properties);
}

export function durationBand(durationSeconds: number): string {
  if (durationSeconds < 30) return "under_30_seconds";
  if (durationSeconds < 60) return "30_to_59_seconds";
  return "60_to_90_seconds";
}
